export enum NetworkCoupling {
    PLUSNET = 'PLUSNET',
    TELEKOM = 'TELEKOM',
    UNKNOWN = 'UNKNOWN',
}
